<template>
<div>
   <!-- <v-chip
      style="bottom: 44px;
        position: fixed;
        z-index: 2000;
        right: 51px;"
      class="ma-2"
      color="red"
      text-color="white"
    >
     <span>DEVELOP-2</span>
    </v-chip> -->
  
  <v-fab-transition>
    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      :style="{
        bottom: fab ? '50px' : '',
        'z-index': 199,
      }"
      aria-label="Scroll to top"
      bottom
      small
      color="primary"
      dark
      fab
      fixed
      right
      title="Scroll to top"
      @click="toTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </v-fab-transition>
</div>

</template>

<script>
export default {
  name: 'AppFab',
  data() {
    return {
      fab: false,
    }
  },
  methods: {
    onScroll() {
      if (typeof window === 'undefined') return
      const top = window.scrollY || document.documentElement.offsetTop || 0
      this.fab = top > 300
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>
